import { Reveal } from "./Reveal";

const SERVICES = [
  {
    letter: "R",
    title: "Home Renovations & New Builds",
    body: "Living rooms, modern puja nooks, modular kitchens, master suites, and verandahs shaped around your family's everyday rituals.",
    deliverables: "3D Views, Civil Drawings, On-site Execution",
    testId: "service-card-residential",
  },
  {
    letter: "C",
    title: "Commercial & Cafe Spaces",
    body: "Vibrant coffee shops, boutique retail stores, and inviting workspaces designed for memorable customer footfall and staff comfort.",
    deliverables: "Brand-aligned Interiors, Lighting & Acoustic Fitouts",
    testId: "service-card-commercial",
  },
  {
    letter: "F",
    title: "Custom Furniture & Styling",
    body: "Handcrafted solid wood dining tables, cane wardrobes, tailored sofas, and curated art accents designed specifically for your dimensions.",
    deliverables: "Material Sourcing, Carpentry & Final Styling",
    testId: "service-card-furniture",
  },
];

export const Services = () => (
  <section id="services" className="py-24 px-6 md:px-10 bg-[#F4EDE2]" data-testid="services-section">
    <div className="max-w-7xl mx-auto space-y-16">
      <Reveal className="max-w-2xl space-y-4">
        <span className="text-xs uppercase tracking-widest text-[#c88c2a] font-semibold">Scope of Work</span>
        <h2 className="font-display text-3xl sm:text-4xl text-[#0D2121]">Complete Interior Services</h2>
        <p className="text-[#7A6F66] text-base">We handle every phase under one roof, removing the stress of managing multiple uncoordinated contractors.</p>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {SERVICES.map((service, i) => (
          <Reveal key={service.title} delay={i * 100}>
            <div
              className="bg-[#FAF6F0] p-8 border border-[#0D2121]/10 flex flex-col justify-between space-y-6 h-full hover:border-[#E2A435]/60 transition-colors"
              data-testid={service.testId}
            >
              <div className="space-y-4">
                <div className="w-10 h-10 bg-[#EADBC8] text-[#c88c2a] flex items-center justify-center font-display font-bold">
                  {service.letter}
                </div>
                <h3 className="font-display text-2xl text-[#0D2121]">{service.title}</h3>
                <p className="text-[#7A6F66] text-sm leading-relaxed">{service.body}</p>
              </div>
              <div className="pt-4 border-t border-[#0D2121]/10">
                <span className="text-xs text-[#7A6F66] uppercase tracking-wider block">Deliverables</span>
                <span className="text-xs text-[#0D2121] font-medium">{service.deliverables}</span>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
